/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ProgressRequestBuilderRequestsMetadata, type ProgressRequestBuilder } from './progress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/signups
 */
export interface SignupsRequestBuilder extends BaseRequestBuilder<SignupsRequestBuilder> {
    /**
     * The progress property
     */
    get progress(): ProgressRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SignupsRequestBuilderUriTemplate = "{+baseurl}/api/signups";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SignupsRequestBuilderNavigationMetadata: Record<Exclude<keyof SignupsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    progress: {
        requestsMetadata: ProgressRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
